import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { firmsAPI, authAPI, settingsAPI } from '../api';
import api from '../api';

export default function Settings() {
  const { user, currentFirm, firms, refreshFirms } = useAuth();
  const [currencies, setCurrencies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [users, setUsers] = useState([]);
  const [pending, setPending] = useState([]);
  const [newCur, setNewCur] = useState({ code:'', rate:'' });
  const [newCat, setNewCat] = useState({ type:'income', name:'' });
  const [newRoom, setNewRoom] = useState('');
  const [pwForm, setPwForm] = useState({ current:'', next:'', confirm:'' });
  const [msg, setMsg] = useState('');
  const [liveRates, setLiveRates] = useState(null);

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 3000); };

  const load = useCallback(async () => {
    if (!currentFirm) return;
    const [curRes, catRes, roomsRes, uRes, pRes] = await Promise.all([
      settingsAPI.getCurrencies(currentFirm.id),
      settingsAPI.getCategories(currentFirm.id),
      api.get(`/firms/${currentFirm.id}/rooms`).catch(()=>({data:[]})),
      authAPI.getUsers().catch(()=>({data:[]})),
      authAPI.getPending().catch(()=>({data:[]})),
    ]);
    setCurrencies(curRes.data);
    setCategories(catRes.data);
    setRooms(roomsRes.data || []);
    setUsers(uRes.data || []);
    setPending(pRes.data || []);
  }, [currentFirm]);

  useEffect(() => { load(); }, [load]);

  const addCurrency = async (e) => { e.preventDefault(); await settingsAPI.addCurrency(currentFirm.id, newCur); setNewCur({code:'',rate:''}); load(); flash('Döviz eklendi.'); };
  const addCategory = async (e) => { e.preventDefault(); await settingsAPI.addCategory(currentFirm.id, newCat); setNewCat({type:'income',name:''}); load(); flash('Kategori eklendi.'); };
  const addRoom = async () => { if (!newRoom.trim()) return; await api.post(`/firms/${currentFirm.id}/rooms`, {name:newRoom.trim()}); setNewRoom(''); load(); flash('Oda eklendi.'); };
  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.next !== pwForm.confirm) { flash('Şifreler eşleşmiyor.'); return; }
    try { await authAPI.changePassword({current:pwForm.current, password:pwForm.next}); setPwForm({current:'',next:'',confirm:''}); flash('Şifre güncellendi.'); }
    catch(err) { flash(err.response?.data?.error || 'Hata.'); }
  };
  const syncRates = async () => { await settingsAPI.syncCurrencies(currentFirm.id); load(); flash('Kurlar güncellendi.'); };
  const approve = async (id) => { await authAPI.approveUser(id); load(); flash('Kullanıcı onaylandı.'); };
  const reject = async (id) => { await authAPI.rejectUser(id); load(); flash('Reddedildi.'); };

  const inp = { height:34, padding:'0 10px', border:'1px solid var(--border)', borderRadius:'var(--radius)', fontSize:13, background:'var(--bg2)', color:'var(--text)' };
  const lbl = { fontSize:11, color:'var(--text2)', marginBottom:4, fontWeight:500 };
  const card = 'card';

  if (!currentFirm) return <div style={{padding:'2rem',color:'var(--text3)',textAlign:'center'}}>Lütfen bir firma seçin.</div>;

  return (
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      {msg && <div style={{padding:'8px 14px',borderRadius:'var(--radius)',background:'var(--green-bg)',color:'var(--green)',border:'1px solid var(--green-border)',fontSize:13}}>✓ {msg}</div>}

      {/* Dövizler */}
      <div className={card}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
          <div style={{fontSize:14,fontWeight:600}}>💱 Döviz Kurları</div>
          <button onClick={syncRates} className="btn btn-ghost btn-sm">↻ Güncelle (TCMB)</button>
        </div>
        <form onSubmit={addCurrency} style={{display:'flex',gap:8,marginBottom:12}}>
          <input value={newCur.code} onChange={e=>setNewCur(f=>({...f,code:e.target.value.toUpperCase()}))} placeholder="USD" style={{...inp,width:80}} maxLength={5} required/>
          <input type="number" value={newCur.rate} onChange={e=>setNewCur(f=>({...f,rate:e.target.value}))} placeholder="Kur (TRY)" style={{...inp,width:140}} min="0" step="0.0001" required/>
          <button type="submit" className="btn btn-dark">+ Ekle</button>
        </form>
        <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
          {currencies.map(c => (
            <div key={c.code} style={{display:'flex',alignItems:'center',gap:8,background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'6px 12px',fontSize:13}}>
              <span style={{fontWeight:500}}>{c.code}</span>
              <span style={{color:'var(--text3)'}}>= ₺{parseFloat(c.rate).toLocaleString('tr-TR',{minimumFractionDigits:4})}</span>
              {c.code !== 'TRY' && <button onClick={async()=>{await settingsAPI.deleteCurrency(currentFirm.id,c.code);load();}} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text3)',fontSize:14}}>×</button>}
            </div>
          ))}
        </div>
      </div>

      {/* Kategoriler */}
      <div className={card}>
        <div style={{fontSize:14,fontWeight:600,marginBottom:12}}>📂 Kategoriler</div>
        <form onSubmit={addCategory} style={{display:'flex',gap:8,marginBottom:12}}>
          <select value={newCat.type} onChange={e=>setNewCat(f=>({...f,type:e.target.value}))} style={{...inp,width:120}}>
            <option value="income">Gelir</option>
            <option value="expense">Gider</option>
          </select>
          <input value={newCat.name} onChange={e=>setNewCat(f=>({...f,name:e.target.value}))} placeholder="Kategori adı..." style={{...inp,flex:1}} required/>
          <button type="submit" className="btn btn-dark">+ Ekle</button>
        </form>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
          {['income','expense'].map(type => (
            <div key={type}>
              <div style={{fontSize:11,color:type==='income'?'var(--green)':'var(--red)',fontWeight:600,marginBottom:8}}>{type==='income'?'↑ Gelir':'↓ Gider'} Kategorileri</div>
              <div style={{display:'flex',flexDirection:'column',gap:4}}>
                {categories.filter(c=>c.type===type).map(c => (
                  <div key={c.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'6px 10px',background:'var(--bg3)',borderRadius:'var(--radius)',fontSize:13}}>
                    <span>{c.name}</span>
                    <button onClick={async()=>{await settingsAPI.deleteCategory(currentFirm.id,c.id);load();}} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text3)',fontSize:14}}>×</button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Odalar */}
      <div className={card}>
        <div style={{fontSize:14,fontWeight:600,marginBottom:12}}>Oda ve daire yönetimi</div>
        <div style={{display:'flex',gap:8,marginBottom:12}}>
          <input value={newRoom} onChange={e=>setNewRoom(e.target.value)} placeholder="Oda adı (101, A-1...)" style={{...inp,flex:1}} onKeyDown={e=>e.key==='Enter'&&addRoom()}/>
          <button onClick={addRoom} className="btn btn-dark">+ Ekle</button>
        </div>
        <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
          {rooms.length===0 && <div style={{fontSize:12,color:'var(--text3)'}}>Henüz oda eklenmedi.</div>}
          {rooms.map(r => (
            <div key={r.id} style={{display:'flex',alignItems:'center',gap:6,background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'5px 10px',fontSize:13}}>
              <span>{r.name}</span>
              <button onClick={async()=>{await api.delete(`/firms/${currentFirm.id}/rooms/${r.id}`);load();}} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text3)',fontSize:14}}>×</button>
            </div>
          ))}
        </div>
      </div>

      {/* Şifre değiştir */}
      <div className={card}>
        <div style={{fontSize:14,fontWeight:600,marginBottom:12}}>🔒 Şifre Değiştir</div>
        <form onSubmit={changePassword} style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          {['current','next','confirm'].map(field => (
            <div key={field}>
              <div style={lbl}>{field==='current'?'Mevcut Şifre':field==='next'?'Yeni Şifre':'Tekrar'}</div>
              <input type="password" value={pwForm[field]} onChange={e=>setPwForm(f=>({...f,[field]:e.target.value}))} style={{...inp,width:160}} required/>
            </div>
          ))}
          <div style={{alignSelf:'flex-end'}}><button type="submit" className="btn btn-dark">Güncelle</button></div>
        </form>
      </div>

      {/* Bekleyen kullanıcılar (admin) */}
      {user?.role==='admin' && pending.length>0 && (
        <div className={card}>
          <div style={{fontSize:14,fontWeight:600,marginBottom:12,color:'var(--yellow-text)'}}>⏳ Onay Bekleyen Kullanıcılar</div>
          {pending.map(u => (
            <div key={u.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid var(--border2)'}}>
              <div style={{fontSize:13,fontWeight:500}}>{u.username}</div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={()=>approve(u.id)} className="btn btn-green btn-sm">Onayla</button>
                <button onClick={()=>reject(u.id)} className="btn btn-sm" style={{background:'var(--red-bg)',color:'var(--red)',border:'1px solid var(--red-border)'}}>Reddet</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
